import { unsetAuthData } from 'app/slice/authSlice';
import store from 'app/store';
import { VI_LANG } from 'constants/global';
import { logoutOidc } from 'oidc';
import Swal from 'sweetalert2';

let isShowing401 = false;

const handleLogout = async () => {
    isShowing401 = false;
    Swal.close();
    store.dispatch(unsetAuthData());
    await logoutOidc();
};

const getMessage401 = (lang, message) => {
    if (isShowing401 || Swal.isVisible()) {
        return;
    }
    isShowing401 = true;

    const isVi = lang === VI_LANG;
    Swal.fire({
        title: isVi ? 'Thất bại' : 'Fail',
        text: message,
        icon: 'error',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        showDenyButton: true,
        denyButtonText: isVi ? 'Đăng xuất' : 'Logout',
    }).then((result) => {
        if (result.isDenied) {
            handleLogout();
        }
    });
};
export default getMessage401;
